import { VITE_EXC_TENANTS } from '@/constants/configs';

export const COMING_SOON_COUNTRIES = [];
export const HIDDEN_COUNTRIES = [];

const COUNTRY_NAME_MAP: Record<string, string> = {
  Cayman: 'Cayman Islands',
};

export const getModifiedCountryName = (name: string) =>
  COUNTRY_NAME_MAP[name] ?? name;

export const EXC_COUNTRIES = VITE_EXC_TENANTS.split(',');
